// extracted by mini-css-extract-plugin
export var container = "_9f-0";
export var icon = "_9f-1";
export var text = "_9f-2";